export const CRM_ROUTE_NAMES = {
    BOARD: "CrmBoard",
};
